import React, { useState, useEffect } from "react";
import { Cell, Label, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import colorCodes from "../../../../../Components/Utils/ColorCode";
import UseGetDashBoardWithParams from "../../../../../Components/Hooks/useDashboardDataParams";
import capitalizeFirstLetter from "../../../../../Components/Utils/Funcs";

function QuotesSubmittedByProcurmentTeamProDash() {
  const [params, setParams] = useState({
    period: "monthly",
  });

  const [selectedPeriod, setSelectedPeriod] = useState("monthly");

  const { data, loading } = UseGetDashBoardWithParams(`/dashboard/QuotesSubmittedByProcurement`, params);

  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    if (data?.customer_request_salesman_wise) {
      const formattedData = data?.customer_request_salesman_wise.map((item) => ({
        name: item.procurementMember || "N/A",
        assign: item.assigned || 0,
        value: item.submitted || 0,
      }));
      setChartData(formattedData);
    }
  }, [data]);

  const hanChange = (e) => {
    setParams({
      period: e.target.value,
    });
    setSelectedPeriod(e.target.value);
  };

  const periods = [
    { value: "monthly", option: "Monthly" },
    { value: "quarterly", option: "Quarterly" },
    { value: "halfyearly", option: "Half Yearly" },
    { value: "yearly", option: "Yearly" },
  ];

  const totalSubmitted = chartData.reduce((acc, cur) => acc + cur.value, 0);

  return (
    <div className="bg-white p-5 rounded-2xl border border-gray-100 shadow-[0_4px_25px_rgba(0,0,0,0.04)] transition-all duration-300 h-full flex flex-col justify-between">
      <div className="flex justify-between items-center pb-3 border-b border-gray-100 mb-3">
        <div className="flex items-center space-x-2">
          <div className="w-7 h-7 rounded-lg bg-purple-50 flex items-center justify-center text-purple-600">
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <h3 className="text-sm font-semibold text-gray-800">Quotes Submitted by Team</h3>
        </div>

        <select
          value={selectedPeriod}
          onChange={hanChange}
          className="bg-gray-50 border border-gray-200 rounded-lg px-2.5 py-1 text-xs font-medium text-gray-700 outline-none"
        >
          {periods.map((period) => (
            <option key={period.value} value={period.value}>
              {period.option}
            </option>
          ))}
        </select>
      </div>

      {loading ? (
        <div className="h-52 flex items-center justify-center animate-pulse">
          <div className="h-36 bg-gray-100 rounded-xl w-full"></div>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-12 gap-3 items-center flex-1">
          {/* Donut Chart */}
          <div className="md:col-span-5 relative flex justify-center items-center h-44">
            {chartData.length > 0 ? (
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={chartData}
                    cx="50%"
                    cy="50%"
                    innerRadius={38}
                    outerRadius={58}
                    paddingAngle={3}
                    dataKey="value"
                    stroke="none"
                  >
                    {chartData.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={colorCodes[index % colorCodes.length]} />
                    ))}
                    <Label
                      value={`${totalSubmitted}`}
                      position="center"
                      style={{ fontSize: "15px", fontWeight: "bold", fill: "#1F2937" }}
                    />
                  </Pie>
                  <Tooltip
                    contentStyle={{
                      backgroundColor: "#1F2937",
                      borderRadius: "8px",
                      color: "#FFF",
                      border: "none",
                      fontSize: "11px",
                    }}
                  />
                </PieChart>
              </ResponsiveContainer>
            ) : (
              <div className="text-center text-gray-400 text-xs font-medium">No quotes data</div>
            )}
          </div>

          {/* Member List */}
          <div className="md:col-span-7 max-h-48 overflow-y-auto pr-1">
            <table className="w-full text-xs">
              <thead className="sticky top-0 bg-gray-50 text-gray-500 font-semibold border-b border-gray-200">
                <tr>
                  <th className="py-1.5 px-2 text-left">Member</th>
                  <th className="py-1.5 px-1 text-center">Assigned</th>
                  <th className="py-1.5 px-2 text-right">Submitted</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {chartData.map((dataItem, idx) => {
                  const color = colorCodes[idx % colorCodes.length];
                  return (
                    <tr key={idx} className="hover:bg-gray-50/70 transition-colors">
                      <td className="py-2 px-2 font-medium text-gray-800 flex items-center space-x-2 truncate max-w-[100px]">
                        <span className="w-2 h-2 rounded-full flex-shrink-0" style={{ backgroundColor: color }}></span>
                        <span className="truncate">{capitalizeFirstLetter(dataItem?.name)}</span>
                      </td>
                      <td className="py-2 px-1 text-center text-gray-600 font-semibold">{dataItem?.assign}</td>
                      <td className="py-2 px-2 text-right font-bold text-purple-600">{dataItem?.value}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

export default QuotesSubmittedByProcurmentTeamProDash;
